import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredDate } from '@/utils/zodUtils';

export const UpdatePaymentDateSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      paymentDate: requiredDate(t),
    })
    .strict();

export type UpdatePaymentDateType = z.infer<ReturnType<typeof UpdatePaymentDateSchema>>;
